import React from 'react';
import { Container } from 'react-bootstrap';
import '../assets/scss/_common.scss';
import airbnb from '../assets/images/airbnb.svg';
import catering from '../assets/images/catering.svg';
import Foundercrate from '../assets/images/Foundercrate.svg';
import komoto from '../assets/images/komoto.svg';
import zoominfo from '../assets/images/zoominfo.svg';

function Services() {
  return (
    <div id="testimonials" className="mt-4 mt-lg-5">
      <div className="fw-600 fnt-16 fnt-lg-20 text-center mb-3 mb-lg-2 text-white">
        Trusted by 5000+ businesses worldwide
      </div>
      <div className="d-md-flex justify-content-between align-items-center">
        <a href="https://www.airbnb.com" target="_blank">
          <img
            src={airbnb}
            alt="airbnb"
            className="service-image mx-3 mb-2 m-0"
          />
        </a>
        <a href="https://www.zoominfo.com/" target="_blank">
          <img
            src={zoominfo}
            alt="zoominfo"
            className="service-image mx-3 mb-2 m-0"
          />
        </a>
        <a href="https://www.foundercrate.com/" target="_blank">
          <img
            src={Foundercrate}
            alt="foundercrate"
            className="service-image mx-3 mb-2 m-0"
          />
        </a>
        <a href="https://kamoto.ai/" target="_blank">
          <img
            src={komoto}
            alt="komoto"
            className="service-image mx-3 mb-2 m-0"
          />
        </a>
        <a href="https://cateringrewards.com/" target="_blank">
          <img
            src={catering}
            alt="catering"
            className="service-image mx-3 mb-2 m-0"
          />
        </a>
      </div>
    </div>
  );
}

export default Services;
